import React, { useState } from 'react';
import InterestFormIndex from './InterestForm';
import InterestTableIndex from './InterestTable';
import BankFormIndex from './BankForm';
import BankTableIndex from './BankTable';
import BankIndex from './Bank';
import BankAccountLimits from './BankAccountLimits';
import AgentTable from './Agent/AgentTable';
import './index.scss';

const GROUPS = [
  {
    label: 'Loan Interest',
    value: 'loan',
    subtabs: [
      { label: 'Create Scheme', index: 0 },
      { label: 'View Schemes', index: 1 },
    ],
  },
  {
    label: 'Bank',
    value: 'bank',
    subtabs: [
      { label: 'Create Bank', index: 2 },
      { label: 'Interest Form', index: 3 },
      { label: 'Interest Table', index: 4 },
    ],
  },
  {
    label: 'Bank Account',
    value: 'account',
    subtabs: [
      // { label: 'Create Account', index: 5 },
      { label: 'Edit Bank Account Name', index: 6 },
    ],
  },
  {
    label: 'Agent',
    value: 'agent',
    subtabs: [
      // { label: 'Create Agent', index: 7 },
      { label: 'Agent List', index: 8 },
    ],
  },
];

export const InterestSchemeIndex = () => {
  const [selectedTab, setSelectedTab] = useState<number>(0);

  return (
    <div className="interest__schemes__page">
      <div className="interest__page__header">
        <h3>Interest Schemes</h3>
        <p>Configure loan schemes, banks, accounts and agents</p>
      </div>

      <div className="interest__layout">
        <nav className="interest__sidenav">
          {GROUPS.map((group) => (
            <div key={group.value} className="interest__nav__group">
              <span className="interest__nav__group__label">{group.label}</span>
              {group.subtabs.map((tab) => (
                <button
                  key={tab.index}
                  className={`interest__nav__item${selectedTab === tab.index ? ' interest__nav__item--active' : ''}`}
                  onClick={() => { setSelectedTab(tab.index); }}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          ))}
        </nav>

        <div className="interest__content">
          {selectedTab === 0 && <InterestFormIndex />}
          {selectedTab === 1 && <InterestTableIndex />}
          {selectedTab === 2 && <BankIndex />}
          {selectedTab === 3 && <BankFormIndex />}
          {selectedTab === 4 && <BankTableIndex />}
          {/* {selectedTab === 5 && <BankAccountIndex />} */}
          {selectedTab === 6 && <BankAccountLimits />}
          {/* {selectedTab === 7 && <AgentForm />} */}
          {selectedTab === 8 && <AgentTable />}
        </div>
      </div>
    </div>
  );
};
